import {CtModelRouteData} from "@ctsolution/ct-framework";

export const WorkOrderInformationRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("workorderinformation");
